export default __webpack_public_path__ + "static/media/Steve Hilton.c1d3be26.jpg";